import React, {useState, useRef} from 'react'
import * as Icon from 'react-feather';
import { Link } from 'react-router-dom';
import './styles.scss'


function Footer() {
    const [click, setClick] = useState(false);
    const [click2, setClick2] = useState(false);
    const [click3, setClick3] = useState(false);
    const [click4, setClick4] = useState(false);

    const handleClick = () => setClick(!click);
    const handleClick2 = () => setClick2(!click2);
    const handleClick3 = () => setClick3(!click3);
    const handleClick4 = () => setClick4(!click4);
    
    const scrollref = useRef(null);

    return (
        <div className="footer-content">
            <div className="fotter-container">
                <div id="newsletter-widget" className="newsletter-dir">
                    <div className="newsletter-widget">
                        <div className="container">
                            <div className="newsletter-container">
                                <div className="newsletter-title">
                                    <svg aria-hidden="true" width="30" focusable="false" data-prefix="fal" data-icon="paper-plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline"><path fill="currentColor" d="M464 4.3L16 262.7C-7 276-4.7 309.9 19.8 320L160 378v102c0 30.2 37.8 43.3 56.7 20.3l60.7-73.8 126.4 52.2c19.1 7.9 40.7-4.2 43.8-24.7l64-417.1C515.7 10.2 487-9 464 4.3zM192 480v-88.8l54.5 22.5L192 480zm224-30.9l-206.2-85.2 199.5-235.8c4.8-5.6-2.9-13.2-8.5-8.4L145.5 337.3 32 290.5 480 32l-64 417.1z" class=""></path>
                                    </svg>
                                    <span>
                                        Sign up to Newsletter
                                    </span>
                                </div>

                                <p>...and receive <span>updates on discounts and new products.</span></p>
                                <form action="" method="post" id="mc-embedded-subscribe-form" class="form-inline form-subscribe" name="mc-embedded-subscribe-form" target="_blank" rel="noopener">
                                    <input class="form-control" type="email" required="" placeholder="Enter your email address" name="EMAIL" id="email-input" />
                                    <button id="email-submit" type="submit" class="btn-custom">Subscribe</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-widget">

                    <div className="footer-inner">
                        <div className="table-row">
                            <div className="row">
                                <div className="each-link">
                                    <div className="footer-block">
                                        <div className="logo-footer" id='contactus'>
                                            <Link to="/" ref={scrollref}>
                                                <span>Solar Scientist<span className="thick-ball">.</span></span>
                                            </Link>
                                        </div>
                                        <div className="support-box-1">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="66" height="55" viewBox="0 0 67 64">
                                                <path d="M32.256 0h2.88c5.824 0.768 11.712 3.008 15.808 7.296 3.84 3.904 5.888 9.152 6.848 14.464 1.024 0.832 2.112 1.728 2.816 2.88 1.984 0.704 3.776 2.048 4.8 3.904 1.088 1.92 1.6 4.032 1.984 6.080v2.88c-0.576 3.264-1.728 6.848-4.544 8.832-0.832 0.64-2.048 0.704-2.688 1.664-0.576 0.896-1.344 1.6-2.24 2.24-0.384 2.688-1.28 5.504-3.136 7.552-1.984 2.24-4.992 3.328-7.936 3.392-1.728 0.064-3.52-0.512-5.184 0.064-1.152 0.768-1.664 2.304-3.072 2.752h-7.744c-2.368-0.064-4.032-2.496-3.776-4.736 0.064-1.856 1.728-3.392 3.584-3.52 2.56-0.192 5.248-0.192 7.808 0.192 1.472 0.192 2.368 1.408 3.2 2.496 3.2 0.192 6.592 0.192 9.536-1.216 2.304-1.088 3.648-3.584 3.968-6.016 0.32-1.28-0.96-1.856-1.728-2.624-0.768-0.64-0.96-1.792-1.024-2.752-0.256-2.56 0-5.184 0.064-7.744 0.128-3.968-0.064-7.936 0.128-11.84 0.064-1.728 0.832-3.584 2.56-4.288-0.704-5.568-3.456-10.88-7.872-14.336-7.552-6.464-19.776-6.528-27.392-0.128-4.224 3.584-6.72 8.896-7.68 14.336 1.344 0.704 2.176 2.048 2.432 3.52 0.576 2.816 0.256 5.76 0.256 8.64-0.128 3.584 0.256 7.104 0.064 10.688-0.192 1.536-0.384 3.264-1.408 4.544-0.96 1.152-2.688 1.344-4.096 0.896-1.216-0.448-1.92-1.664-2.624-2.688-2.24-0.704-4.096-2.24-5.12-4.352-0.896-1.728-1.408-3.648-1.728-5.568v-2.88c0.384-2.112 0.896-4.224 1.984-6.080 1.024-1.92 2.88-3.264 4.928-3.904 0.448-1.28 1.664-2.048 2.688-2.88 0.96-5.504 3.2-11.008 7.296-14.976 4.16-3.968 9.728-6.016 15.36-6.784M9.792 24.832c-0.64 6.528-0.128 13.12-0.384 19.648-0.064 1.024 0.064 2.112 0.576 3.072 0.576-0.064 1.28 0.192 1.728-0.192 0.704-1.408 0.448-3.072 0.384-4.608 0-6.016 0.256-12.032-0.256-17.984-0.64-0.192-1.536-0.448-2.048 0.064M55.552 24.768c-0.576 6.656-0.128 13.312-0.384 20.032 0 0.832 0.128 1.792 0.512 2.56 0.448 0.384 1.152 0.128 1.664 0.192 0.832-1.472 0.576-3.2 0.576-4.8-0.064-6.016 0.256-12.032-0.32-18.048-0.704-0.192-1.408-0.256-2.048 0.064M3.584 31.104c-1.024 2.752-1.088 5.76-0.384 8.64 0.448 1.984 1.536 4.032 3.52 4.864-0.064-5.696 0.192-11.456-0.128-17.152-1.472 0.704-2.496 2.112-3.008 3.648M60.672 27.456c0.064 5.696-0.192 11.456 0.128 17.152 1.216-0.64 2.176-1.728 2.752-2.944 1.152-2.624 1.28-5.568 0.832-8.384-0.384-2.304-1.472-4.8-3.712-5.824M29.824 60.8c2.944 0.64 6.080 0.64 9.088 0 0.192-0.64 0.192-1.344 0-1.984-2.816-0.064-5.76-0.896-8.512-0.064-0.96 0.256-0.896 1.28-0.576 2.048z"></path>
                                            </svg>
                                            <div class="text">
                                                <span>Got questions? Call us 24/7!</span>
                                                <span>(+234) 810-179-1751, (+234) 803-487-3178</span>
                                            </div>
                                        </div>
                                        <div className="support-box-2">
                                            <div class="text">
                                                <span>Contact info</span>
                                                <span> Office B3 Suite12GF, Aregbesola Shopping Mall Ipaja Road Pako Bus-Stop  Lagos.</span>
                                            </div>
                                        </div>
                                        <div className="widget-social">
                                            <ul class="widget-social-icons list-inline">

                                                <li>
                                                    <a target="_blank" rel="noopener" href="https://www.facebook.com/" title="Facebook">

                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 37 64">
                                                            <path d="M34.24 0.448v9.408h-5.568q-3.072 0-4.16 1.28t-1.088 3.84v6.784h10.496l-1.408 10.56h-9.088v27.136h-10.944v-27.136h-9.088v-10.56h9.088v-7.808q0-6.656 3.712-10.304t9.92-3.648q5.248 0 8.128 0.448z"></path>
                                                        </svg>

                                                    </a>
                                                </li>

                                                <li>
                                                    <a target="_blank" rel="noopener" href="https://www.twitter.com/" title="Twitter">

                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 79 64">

                                                            <path d="M78.784 7.552q-3.264 4.928-8.064 8.384 0.064 0.896 0.064 2.048 0 6.528-1.92 12.992-1.856 6.528-5.76 12.48-3.904 5.888-9.28 10.496t-12.864 7.296q-7.552 2.752-16.192 2.752-13.44 0-24.768-7.232 1.984 0.192 3.84 0.192 11.264 0 20.096-6.912-5.248-0.128-9.408-3.264-4.096-3.136-5.696-8 1.536 0.32 3.072 0.32 2.176 0 4.224-0.576-5.568-1.088-9.28-5.568-3.648-4.416-3.648-10.24v-0.256q3.392 1.92 7.296 2.048-3.328-2.176-5.248-5.76-1.92-3.52-1.92-7.68 0-4.352 2.176-8.128 6.080 7.488 14.72 11.904 8.64 4.48 18.56 4.992-0.384-1.792-0.384-3.712 0-6.656 4.736-11.392t11.392-4.736q7.040 0 11.84 5.12 5.44-1.088 10.24-3.968-1.856 5.824-7.104 8.96 4.864-0.576 9.28-2.56z"></path>
                                                        </svg>

                                                    </a>
                                                </li>

                                                <li>
                                                    <a target="_blank" rel="noopener" href="https://www.instagram.com/" title="Instagram">

                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 55 64">

                                                            <path d="M44.16 32q0-1.664-0.384-3.2h11.264v22.016q0 3.584-2.496 6.144t-6.080 2.56h-37.888q-3.584 0-6.080-2.56t-2.496-6.144v-22.016h11.136q-0.256 2.048-0.256 3.2 0 6.784 4.864 11.712t11.776 4.928q6.784 0 11.712-4.928t4.928-11.712zM46.464 4.48q3.584 0 6.080 2.496t2.496 6.080v9.344h-13.952q-4.992-7.040-13.568-7.040-8.832 0-13.568 7.040h-13.952v-9.344q0-3.584 2.496-6.080t6.080-2.496h37.888zM50.56 15.104v-4.608q0-1.536-1.536-1.536h-4.608q-1.536 0-1.536 1.536v4.608q0 0.512 0.448 1.024t1.088 0.512h4.608q1.536 0 1.536-1.536zM37.76 32q0 4.224-3.008 7.232t-7.232 3.008-7.232-3.008-3.008-7.232q0-4.352 3.008-7.296t7.232-2.944 7.232 2.944 3.008 7.296z"></path>
                                                        </svg>

                                                    </a>
                                                </li>
                                                {/* <li>
                                                    <a target="_blank" rel="noopener" href="https://www.pinterest.com/" title="Pinterest">

                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 55 64">
                                                            <title>pinterest-circled</title>
                                                            <path d="M54.848 32q0 7.488-3.648 13.76t-9.984 9.984-13.76 3.712q-3.968 0-7.808-1.152 2.112-3.328 2.752-5.888 0.384-1.216 1.984-7.552 0.704 1.408 2.56 2.432t4.096 1.024q4.352 0 7.744-2.432t5.248-6.72 1.856-9.664q0-4.096-2.176-7.68t-6.144-5.76-9.088-2.304q-3.776 0-7.040 1.088t-5.504 2.752-3.904 3.904-2.368 4.608-0.768 4.8q0 3.712 1.408 6.528t4.224 3.968q1.024 0.448 1.344-0.704 0.064-0.256 0.256-1.088t0.32-1.088q0.192-0.832-0.384-1.536-1.856-2.176-1.856-5.376 0-5.376 3.712-9.28t9.792-3.904q5.376 0 8.448 2.944t3.008 7.616q0 6.080-2.496 10.304t-6.272 4.288q-2.176 0-3.456-1.6t-0.832-3.712q0.256-1.216 0.96-3.328t1.088-3.648 0.384-2.752q0-1.792-0.96-2.944t-2.752-1.152q-2.24 0-3.776 1.984t-1.536 5.12q0 2.56 0.896 4.352l-3.52 14.912q-0.576 2.496-0.448 6.336-7.36-3.264-11.904-10.048t-4.544-15.104q0-7.488 3.712-13.76t9.92-9.984 13.824-3.712 13.76 3.712 9.984 9.984 3.648 13.76z"></path>
                                                        </svg>

                                                    </a>
                                                </li> */}
                                                <li>
                                                    <a target="_blank" rel="noopener" href="https://www.youtube.com/" title="Youtube">

                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64">

                                                            <path d="M25.408 40.256l17.28-8.896-17.28-9.024v17.92zM32 9.472q6.016 0 11.584 0.192t8.192 0.32l2.624 0.128q0 0 0.576 0.064t0.832 0.128 0.832 0.128 1.024 0.32 1.024 0.448 1.088 0.704 1.024 0.96q0.256 0.192 0.576 0.64t1.024 2.112 0.96 3.584q0.256 2.304 0.448 4.864t0.192 4.096v6.272q0.064 5.184-0.64 10.368-0.256 1.92-0.896 3.52t-1.152 2.24l-0.512 0.576q-0.448 0.512-1.024 0.96t-1.088 0.64-1.024 0.448-1.024 0.32-0.832 0.128-0.832 0.128-0.576 0.064q-8.96 0.704-22.4 0.704-7.36-0.128-12.864-0.256t-7.104-0.256l-1.792-0.192-1.28-0.128q-1.28-0.192-1.92-0.32t-1.856-0.768-1.984-1.472q-0.256-0.192-0.576-0.64t-1.024-2.112-0.96-3.584q-0.256-2.304-0.448-4.864t-0.192-4.096v-6.272q-0.064-5.184 0.64-10.368 0.256-1.984 0.896-3.52t1.152-2.24l0.512-0.576q0.512-0.576 1.024-0.96t1.088-0.704 1.024-0.448 1.024-0.32 0.832-0.128 0.832-0.128 0.576-0.064q8.96-0.64 22.4-0.64z"></path>
                                                        </svg>

                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="each-link">
                                    <div className="footer-block" onClick={handleClick}>
                                        <h6 className='footer-nav-head'>Find In Fast
                                            <span class={click? "icon active" : 'icon'}>
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 41 64">
                                                    <path d="M38.4 26.304q0 0.448-0.384 0.768l-16.64 16.704q-0.32 0.32-0.832 0.32t-0.768-0.32l-16.64-16.704q-0.384-0.32-0.384-0.768t0.384-0.832l1.792-1.792q0.32-0.384 0.768-0.384t0.832 0.384l14.016 14.016 14.080-14.016q0.32-0.384 0.832-0.384t0.768 0.384l1.792 1.792q0.384 0.32 0.384 0.832z"></path></svg>
                                            </span>
                                        </h6>

                                        <ul className={click? "f-list active" : 'f-list'}>
                                            <li>
                                                <a href="/collections/accessories">
                                                    <span>
                                                        Inverters
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/gaming">
                                                    <span>
                                                        Batteries
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/laptops-computer">
                                                    <span>
                                                        Solar Panels
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/mac-computers">
                                                    <span>
                                                        Power Saving Electronics
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/pc-computers">
                                                    <span>
                                                        Lighting
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/ultrabooks">
                                                    <span>
                                                        CCTV
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="each-link">
                                    <div className="footer-block" onClick={handleClick2}>
                                        <h6 className='footer-nav-head hide-title'>
                                            Information
                                            <span class="icon">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 41 64"><path d="M38.4 26.304q0 0.448-0.384 0.768l-16.64 16.704q-0.32 0.32-0.832 0.32t-0.768-0.32l-16.64-16.704q-0.384-0.32-0.384-0.768t0.384-0.832l1.792-1.792q0.32-0.384 0.768-0.384t0.832 0.384l14.016 14.016 14.080-14.016q0.32-0.384 0.832-0.384t0.768 0.384l1.792 1.792q0.384 0.32 0.384 0.832z"></path></svg></span></h6>
                                        <ul className={click2? "f-list active" : 'f-list'}>
                                            <li>
                                                <a href="/collections/accessories">
                                                    <span>
                                                        About Us
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/gaming">
                                                    <span>
                                                        Contact Us
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/laptops-computer">
                                                    <span>
                                                        All Collections
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/mac-computers">
                                                    <span>
                                                        Privacy policy
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/pc-computers">
                                                    <span>
                                                        Terms & Conditions
                                                    </span>
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href="/collections/ultrabooks">
                                                    <span>
                                                        Ultrabooks
                                                    </span>
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>

                                <div className="each-link">
                                    <div className="footer-block" onClick={handleClick3}>
                                        <h6 className='footer-nav-head'>In the Spotlight<span className="icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 41 64"><path d="M38.4 26.304q0 0.448-0.384 0.768l-16.64 16.704q-0.32 0.32-0.832 0.32t-0.768-0.32l-16.64-16.704q-0.384-0.32-0.384-0.768t0.384-0.832l1.792-1.792q0.32-0.384 0.768-0.384t0.832 0.384l14.016 14.016 14.080-14.016q0.32-0.384 0.832-0.384t0.768 0.384l1.792 1.792q0.384 0.32 0.384 0.832z"></path></svg></span></h6>

                                        <ul className={click3? "f-list active" : 'f-list'}>
                                            <li>
                                                <a href="/collections/accessories">
                                                    <span>
                                                        Wishlist
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/gaming">
                                                    <span>
                                                        Shipping & Return
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/laptops-computer">
                                                    <span>
                                                        FAQs
                                                    </span>
                                                </a>
                                            </li>
                                            {/* <li>
                                                <a href="/collections/mac-computers">
                                                    <span>
                                                        Mac Computers
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/pc-computers">
                                                    <span>
                                                        PC Computers
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/ultrabooks">
                                                    <span>
                                                        Ultrabooks
                                                    </span>
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>

                                <div className="each-link">
                                    <div className="footer-block" onClick={handleClick4}>
                                        <h6 className='footer-nav-head'>Customer Care<span className="icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 41 64"><path d="M38.4 26.304q0 0.448-0.384 0.768l-16.64 16.704q-0.32 0.32-0.832 0.32t-0.768-0.32l-16.64-16.704q-0.384-0.32-0.384-0.768t0.384-0.832l1.792-1.792q0.32-0.384 0.768-0.384t0.832 0.384l14.016 14.016 14.080-14.016q0.32-0.384 0.832-0.384t0.768 0.384l1.792 1.792q0.384 0.32 0.384 0.832z"></path></svg></span></h6>

                                        <ul className={click4? "f-list active" : 'f-list'}>
                                            <li>
                                                <a href="/collections/accessories">
                                                    <span>
                                                        ...
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/gaming">
                                                    <span>
                                                        ...
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/laptops-computer">
                                                    <span>
                                                        ... &amp; ...
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/mac-computers">
                                                    <span>
                                                        ...
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/pc-computers">
                                                    <span>
                                                        ...
                                                    </span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/collections/ultrabooks">
                                                    <span>
                                                        ...
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className="footer-bot">
                    <div class="container">
                        <div class="table-row">

                            <div class="copyright">
                                <p>© 2022 <strong>Solar Scientist</strong>. All Rights Reserved</p>
                            </div>
                            {/* <div class="payment-icons">

                                <div class="list-inline">

                                    <div className="lazy-load">
                                        <img src={card1} />


                                        <img src={card1} />
                                    </div>
                                </div>

                            </div> */}

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Footer
